import React from 'react';
import CompanyValues from '../components/CompanyValues';
import { Car, Users, Shield, Award } from 'lucide-react';

const About: React.FC = () => {
  const stats = [
    { icon: <Car className="h-8 w-8 text-blue-600" />, number: '10,000+', label: 'Vehicles Managed Daily' },
    { icon: <Users className="h-8 w-8 text-blue-600" />, number: '1,500+', label: 'Parking Spaces Listed' },
    { icon: <Shield className="h-8 w-8 text-blue-600" />, number: '99.9%', label: 'System Uptime' },
    { icon: <Award className="h-8 w-8 text-blue-600" />, number: '24hr', label: 'Quick Setup Time' },
  ];

  return (
    <div className="pt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            About Park Hive
          </h1>
          <p className="text-lg text-gray-600">
            A modern, automated Parking Management System that gives parking owners and operators complete control over their parking space — from a single mobile app.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-blue-100 rounded-lg">
                  {stat.icon}
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-20">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h2>
            <p className="text-lg text-gray-600 mb-8">
              To transform parking management through innovative technology that eliminates bottlenecks, accelerates movement, and provides complete operational control without complexity. We believe parking should not feel like a battlefield — it should be intelligent, seamless, and profitable.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Complete Control</h3>
                <p className="text-gray-600">
                  Everything you need to run professional parking lives inside your smartphone.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Zero Complexity</h3>
                <p className="text-gray-600">
                  No bulky hardware. No complicated installations. No long staff training.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Real Intelligence</h3>
                <p className="text-gray-600">
                  Every second recorded. Every transaction traceable. Every decision visible.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <CompanyValues />
    </div>
  );
};

export default About;